export default "__VITE_ASSET__CZq9sUpH__"